import { useAuth0 } from '@auth0/auth0-react'

import { faShieldAlt, faUserCog } from '@fortawesome/pro-light-svg-icons'

import { TopBar } from '@domain-group/suit-theme'

const clearUserData = () => {
  // Clear cookie
  document.cookie = `authenticatedUser=; path=/; max-age=0`
  document.cookie = `lastEmail=; path=/; max-age=0`
  document.cookie = `CurrentEmail=; path=/; max-age=0`
}

const LoggedInUser = () => {
  const { logout, user } = useAuth0()
  const { 'https://www.realhubapp.com/role': roleName, name, picture } = user || {}

  return (
    <TopBar.LoggedInUser
      callbacks={{ logout: () =>{
        logout({ 
          returnTo: window.location.origin 
        })
        clearUserData()} 
      }}
      imageUrl={picture}
      title={name}
      subtitle={roleName}
    >
      <TopBar.DropdownLink href="#" icon={faUserCog} text="Admin Settings" />
      <TopBar.DropdownLink href="#" icon={faShieldAlt} text="Account Settings" />
    </TopBar.LoggedInUser>
  )
}

export default LoggedInUser
